import React, {Component} from 'react';
import {Icon, Popover} from 'antd';
import LeftMenu from '../LeftMenu';
import logo from '../../images/logo.png';
import QRCode from '../../images/QRCode.jpg';
import './index.scss';

export default class LeftNav extends Component {
    render() {
        const {onMenuClick, activeMenuIndex} = this.props;
        return (
            <div className="left_nav">
                <img width={103} height={102} src={logo} className="logo" alt={'黄羲博物馆'}/>
                <LeftMenu onMenuClick={onMenuClick} activeMenuIndex={activeMenuIndex}/>
                <div className="bottom_panel">
                    <Popover content={(
                        <div style={{textAlign: 'center'}}>
                            <img src={QRCode} width={150} height={150} alt={''}/>
                            <p>
                                打开微信扫一扫
                                <br/>
                                关注黄羲博物馆公众号
                            </p>
                        </div>
                    )}>
                        <Icon type={'wechat'} className="wechat_icon"/>
                    </Popover>
                    <p>
                        黄羲博物馆版权所有
                        <br />
                        沪IPC备14053163</p>
                </div>
            </div>
        );
    }
}